<template>
    <page :tabs="tabs" :busy="busy">
        <grid :columnDefs="columnDefs" :rowData="rowData" :isAutoWidth="true">
            <responsive-button
                @click="$bvModal.show(createCalendarId)"
                :icon="['fas', 'plus']"
                variant="primary"
                >Add Calendar</responsive-button
            >
            <holidays-imports-modal
                :initialValues="null"
                :busy="busy"
                :modalId="createCalendarId"
                @submit="createCalendar"
            />
        </grid>
    </page>
</template>

<script>
import Page from '../../generic/page/page.vue';
import grid from '../../generic/grid/grid.vue';
import ResponsiveButton from '../../generic/responsive-button/responsive-button.vue';
import ActionsCellRenderer from './actions-cell-renderer.vue';
import api from '../../../api';
import { ADMIN_IMPORT_HOLIDAY_ENDPOINT } from '../../../endpoints';
import { formatResponseError } from '../../../utils/api';
import HolidaysImportsModal from './holidays-imports-modal.vue';

export default {
    components: {
        Page,
        grid,
        ResponsiveButton,
        HolidaysImportsModal,
        actionsCellRenderer: ActionsCellRenderer,
    },
    data() {
        return {
            busy: false,
            createCalendarId: 'create-calendar-id',
            tabs: [
                {
                    title: 'Import Holidays',
                    active: true,
                },
            ],
            rowData: [],
        };
    },
    computed: {
        columnDefs() {
            return [
                {
                    field: 'country.name',
                    headerName: 'Country',
                },
                {
                    field: 'calendar_name',
                    headerName: 'Calendar Name',
                    sort: 'asc',
                    autoWidthExclude: true,
                },
                {
                    field: '',
                    headerName: '',
                    autoWidthExclude: true,
                    minWidth: 160,
                    maxWidth: 160,
                    cellRenderer: 'actionsCellRenderer',
                    cellRendererParams: {
                        deleteCalendar: async (id) => {
                            try {
                                this.busy = true;
                                await api.delete(
                                    ADMIN_IMPORT_HOLIDAY_ENDPOINT(id)
                                );
                                await this.fetchData();
                            } catch (e) {
                                const { generic } = formatResponseError(e);
                                this.errorToast({
                                    text:
                                        generic || 'Could not delete calendar',
                                });
                            } finally {
                                this.busy = false;
                            }
                        },
                        updateCalendar: async (values, modalId) => {
                            try {
                                this.busy = true;
                                await api.patch(
                                    ADMIN_IMPORT_HOLIDAY_ENDPOINT(values.id),
                                    values
                                );
                                this.$bvModal.hide(modalId);
                                await this.fetchData();
                            } catch (e) {
                                const { generic } = formatResponseError(e);
                                this.errorToast({
                                    text:
                                        generic || 'Could not update calendar',
                                });
                            } finally {
                                this.busy = false;
                            }
                        },
                    },
                },
            ];
        },
    },
    created() {
        this.fetchData();
    },
    methods: {
        async fetchData() {
            try {
                this.busy = true;
                const { data } = await api.get(ADMIN_IMPORT_HOLIDAY_ENDPOINT());
                this.rowData = data;
            } catch (e) {
                const { generic } = formatResponseError(e);
                this.errorToast({
                    text: generic || 'Could not fetch holidays',
                });
            } finally {
                this.busy = false;
            }
        },
        async createCalendar(values) {
            try {
                this.busy = true;
                await api.post(ADMIN_IMPORT_HOLIDAY_ENDPOINT(), values);
                await this.fetchData();
                this.$bvModal.hide(this.createCalendarId);
            } catch (e) {
                const { generic } = formatResponseError(e);
                this.errorToast({
                    text: generic || 'Could not create calendar',
                });
            } finally {
                this.busy = false;
            }
        },
    },
};
</script>

<style>
</style>